module.exports = __webpack_public_path__ + "static/img/ueberuns_stand.7215666.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ueberuns_stand.png
// module id = 0Skj
// module chunks = 2